// 40px radio pills for phone sheets. `dashed` marks unpaid preview horizons.
export default function PillGroup({ options, value, onChange, ariaLabel }) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const on = opt.value === value;
        const idle = opt.dashed
          ? 'border-dashed border-gray-300 dark:border-gray-500'
          : 'border-gray-200/70 dark:border-gray-600/70';
        return (
          <button
            key={String(opt.value)}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={opt.disabled}
            onClick={() => onChange(opt.value)}
            className={`h-10 rounded-full border px-3.5 text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-40 ${
              on
                ? 'border-brand-400 bg-brand-50 font-semibold text-brand-700 dark:border-brand-600 dark:bg-brand-900/30 dark:text-brand-300'
                : `${idle} bg-surface font-medium text-gray-700 dark:bg-gray-870 dark:text-gray-300`
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
